module.exports = __webpack_public_path__ + "static/media/garlicnchickenseekh.ff6fcc8a.jpg";